module.exports = __webpack_public_path__ + "img/insure1.1e6e88ad.png";